export default {
	bind(el) {
		/**
		 * The `binding` object is immutable in a Vue 2 directive,
		 * only `el` can persist state across.
		 */
		el._updateTableStyles = () => {
			/**
			 * Toggle `table--sticky` class:
			 */
			el.classList[el.getBoundingClientRect().top <= 0 ? 'add' : 'remove']('table--sticky');
		};
		document.addEventListener('load', el._updateTableStyles, false);
		document.addEventListener('scroll', el._updateTableStyles, false);
		window.addEventListener('resize', el._updateTableStyles, false);
	},
	unbind(el) {
		document.removeEventListener('load', el._updateTableStyles, false);
		document.removeEventListener('scroll', el._updateTableStyles, false);
		window.removeEventListener('resize', el._updateTableStyles, false);
	}
};



// WEBPACK FOOTER //
// ./app/directives/table.js